import React, { useEffect, useState } from "react";
import {
  BASE_FILE_URL,
  BASE_URL,
  CleanKey,
  valueOptionSensorIds,
} from "../../../constant";
import axios from "axios";
import Loader from "../../Loader";
import { rangeOption } from "../../../constant";
import { ToggleButton } from "@progress/kendo-react-dateinputs";
import { useTranslation } from "react-i18next";

const Mapping = ({ device, setDevice, selectedSensorIndex, setOpen }) => {
  const defaultform = {
    value: "",
    description: "",
    iconId: "",
    iconName: "",
  };
  const unknownValueForm = {
    value: "unknown",
    description: "",
    iconId: "",
    iconName: "",
  };

  const { t } = useTranslation();
  const [selectedSensor, setSelectedSensor] = useState();
  const [mapping, setMapping] = useState([defaultform]);
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(100);
  const [mappingOptions, setMappingOptions] = useState([]);
  const [unknownValueChecked, setUnknownValueChecked] = useState(false);

  const onHandleChange = (e, index) => {
    setMapping(
      mapping.map((m, i) =>
        index === i ? { ...m, [e.target.name]: e.target.value } : m
      )
    );
  };

  const onSave = async () => {
    setLoading(true);
    const config = { headers: { "Content-Type": "multipart/form-data" } };
    const formData = new FormData();

    mapping.forEach((m) => {
      formData.append("files", m.file);
    });
    try {
      const res = await axios.post(
        `${BASE_URL}/Storage/file/upload`,
        formData,
        config
      );
      const uploadedImages = res.data;

      // Save the uploaded image IDs in the uploadedImages state array
      // setUploadedImages(uploadedImageIds);
      setDevice((pre) => ({
        ...pre,
        sensors: pre.sensors.map((s, index) =>
          index === selectedSensorIndex
            ? {
                ...s,
                mappings: {
                  data: mapping.map((m, i) =>
                    m.file
                      ? {
                          ...m,
                          iconId: uploadedImages.find(
                            (n) => n.fileName === m.iconName
                          )?.id,
                        }
                      : m
                  ),
                  displayOption: selectedOption,
                  unknownValue: unknownValueChecked,
                },
              }
            : s
        ),
      }));
      setLoading(false);
    } catch (error) {
      console.error("Error occurred during upload:", error.message);
      setLoading(false);
    }

    setOpen();
  };

  const onFileChange = (event, index) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setMapping((prevMapping) =>
        prevMapping.map((m, i) =>
          index === i ? { ...m, file, iconName: file.name, loading: true } : m
        )
      );
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const onClose = () => {
    setOpen();
  };

  const addRow = () => {
    setMapping([...mapping, defaultform]);
  };

  // const deleteRow = (i) => {
  //   setMapping(mapping.filter((_, index) => index !== i));
  // };

  const deleteRow = (i) => {
    setMapping((prevMapping) => {
      const updatedMapping = prevMapping.filter((_, index) => index !== i);
      if (prevMapping[i].value === "unknown") {
        setUnknownValueChecked(false);
      }
      return updatedMapping;
    });
  };

  const handleCheckboxChange = () => {
    setUnknownValueChecked((prev) => {
      const newCheckedState = !prev;
      if (newCheckedState) {
        setMapping((prevMapping) => [unknownValueForm, ...prevMapping]);
      } else {
        setMapping((prevMapping) =>
          prevMapping.filter((m) => m.value !== "unknown")
        );
      }
      return newCheckedState;
    });
  };

  useEffect(() => {
    const sensor = device.sensors.find((_, i) => i === selectedSensorIndex);
    setSelectedSensor(sensor);
    if (sensor && sensor.mappings?.data && sensor.mappings.data.length > 0) {
      setMapping(sensor.mappings.data);
      setSelectedOption(sensor.mappings.displayOption);
      setUnknownValueChecked(sensor.mappings.unknownValue);
    }
    // if (valueOptionSensorIds.includes(sensor.id)) {
    //   setMappingOptions(valueOption);
    // } else {
    //   setMappingOptions(rangeOption);
    // }
  }, []);

  return (
    <div class="relative h-[55vh] shadow-md sm:rounded-lg dark:bg-neutral-900 bg-zinc-300 p-3">
      <div className="flex justify-between">
        <h2 className="text-2xl font-bold dark:text-white text-black">
          {selectedSensor?.name} - {t("masters.headerTexts.mapping")}
        </h2>
        <div className="flex ml-0 items-center w-fit gap-3 justify-between">
          <input
            type="checkbox"
            name="unknownValue"
            placeholder="Enter Description"
            className="focus:ring-blue-500 h-4 lg:h-4 w-3 lg:w-4 text-blue-600 border-gray-300 rounded"
            onChange={handleCheckboxChange}
            checked={unknownValueChecked}
          />
          <label className="dark:text-white text-black text-xs lg:text-sm font-medium">
            Unknown Value
          </label>
        </div>
      </div>

      <div className="overflow-y-auto h-3/5 py-4">
        <table class="w-full text-sm text-left text-white -m-px pb-2">
          <thead class="text-xs sticky top-0 dark:text-white text-black uppercase dark:bg-neutral-800 bg-zinc-200 z-50">
            <tr>
              <th scope="col" class="px-6 py-1">
                {t("masters.fields.value")}
              </th>
              <th scope="col" class="px-6 py-1">
                {t("masters.fields.text")}
              </th>
              <th scope="col" class="px-6 py-1">
                {t("masters.fields.icon")}
              </th>
              <th scope="col" class="px-6 py-1">
                <div className="flex gap-1 justify-center items-center">
                  <label className="mt-1">{t("masters.fields.action")}</label>
                  <button
                    class=" h-fit text-green-400 text-2xl font-medium flex items-center focus:outline-0"
                    onClick={addRow}
                    disabled={mapping.some(
                      (rd) => rd.value === "" || rd.description === ""
                    )}
                  >
                    +
                  </button>
                </div>
              </th>
            </tr>
          </thead>
          <tbody className="">
            {mapping.map((rd, index) => (
              <tr class="dark:bg-neutral-700 bg-zinc-100 border-b border-slate-800" key={index}>
                <td
                  scope="row"
                  class=" font-medium dark:text-white text-black whitespace-nowrap py-1"
                >
                  <input
                    type="text"
                    name="value"
                    className="w-full h-full bg-inherit border dark:border-slate-500 border-slate-400 rounded-lg px-3 mx-1 py-3 focus:outline-0 "
                    onChange={(e) => onHandleChange(e, index)}
                    value={rd.value}
                    readOnly={rd.value === "unknown"}
                  />
                </td>
                <td class="py-1 dark:text-white text-black">
                  <input
                    type="text"
                    name="description"
                    className="w-full h-full bg-inherit border dark:border-slate-500 border-slate-400 rounded-lg px-3 mx-1 py-3 focus:outline-0"
                    onChange={(e) => onHandleChange(e, index)}
                    value={rd.description}
                    readOnly={rd.description === "unknown"}
                  />
                </td>
                <td className="h-full py-1">
                  <label
                    for="dropzone-file"
                    class="flex flex-col relative items-center mx-2  justify-center w-full h-full border-2 dark:border-gray-700 border-zinc-500 border-dashed rounded-lg cursor-pointer dark:bg-gray-600 bg-zinc-400"
                  >
                    <div class="flex items-center gap-1 px-2 h-10 justify-center">
                      {rd.file ||
                      (rd.iconId && !rd.iconId.startsWith("0000")) ? (
                        <img
                          src={
                            rd.file && rd.file.name
                              ? URL.createObjectURL(rd.file)
                              : rd.iconId && BASE_FILE_URL + "/" + rd.iconId
                          }
                          alt="icon"
                          className="h-6 w-auto image-full hover:fill-white"
                        />
                      ) : (
                        <svg
                          class="w-4 h-4 text-gray-500 dark:text-gray-400"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 20 16"
                        >
                          <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                          />
                        </svg>
                      )}
                      <input
                        type="file"
                        className="absolute cursor-pointer h-full w-full border-0 focus:outline-none opacity-0"
                        name="file"
                        onChange={(e) => onFileChange(e, index)}
                      />
                    </div>
                    {/* // ) : (
                      
                    // )} */}
                  </label>
                </td>
                <td className="py-1">
                  <div className="flex item-center justify-center gap-4 px-4 py-3 ">
                    <button
                      class="font-medium flex items-center text-white focus:outline-0"
                      onClick={() => deleteRow(index)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 20"
                        stroke-width="1.5"
                        stroke="rgb(248 113 113)"
                        class="w-4 h-4 text-red-600"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                        />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Option buttons */}
      <div>
        {/* <div className="flex w-full">
          <labal>Option Type</labal>
          <input type="radio" />
          <input type="radio" />
        </div> */}
        <div className="flex items-start gap-2 py-2 px-3 bg-inherit absolute bottom-12 right-0 rounded-sm w-full">
          <label className="flex text-xs mt-1 dark:text-white text-black">
            {t("masters.fields.options")}:
          </label>
          <div className="grid grid-cols-2 gap-4">
            {rangeOption.map((option) => (
              <button
                key={option.id}
                className={`${
                  selectedOption === option.id ? "bg-blue-600" : "dark:bg-gray-600 bg-zinc-500"
                } text-xxs text-white p-1 rounded-lg flex items-center justify-center gap-2`}
                onClick={() => setSelectedOption(option.id)}
              >
                {selectedOption === option.id && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#66ff33"
                    className="w-4 h-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                )}
                {t(`rangeOption.${CleanKey(option.value)}`)}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2 py-2 px-3 bg-inherit rounded-sm absolute bottom-1 right-0 w-full justify-end">
        <button
          type="button"
          name="close"
          onClick={onClose}
          className="text-black bg-white text-xs lg:text-sm rounded-4xl px-auto py-auto lg:w-20 h-7"
        >
          {t("button.close")}
        </button>
        <button
          type="button"
          name="save"
          onClick={onSave}
          className=" text-white bg-indigo-700 flex justify-center gap-2 text-xs lg:text-sm rounded-4xl px-auto items-center lg:w-20 h-7"
          disabled={
            mapping.some((m) => m.value === "" || m.description === "") ||
            loading
          }
        >
          {t("button.save")}
          {loading && (
            <svg class="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24">
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          )}
        </button>
      </div>
    </div>
  );
};

export default Mapping;
